module.exports = __webpack_public_path__ + "img/PXL_20230524_174751200.2f2c5a0c.jpg";